// extracted by mini-css-extract-plugin
export default {"wrapper":"DropdownItem_wrapper_olDer","disabled":"DropdownItem_disabled_QV5nt"};